import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { PreferenceService } from '@bingads-webui/preference-service';
import { PreferenceContext } from '@bingads-webui-react/preference-context';

// Asynchronously initializes PreferenceService and doesn't render children until it's ready.
export function PreferenceContextProvider(props) {
  const { children } = props;
  const serverContext = useContext(ServerContext);

  const [shouldRender, setShouldRender] = useState(false);
  const [preferenceInitialized, setPreferenceInitialized] = useState(false);

  useEffect(() => {
    const {
      UserPreferences,
      CurrentUser,
      CurrentCustomer,
      CurrentAccount,
      ServicesEndpoints: { CampaignAPI } = {},
      CampaignAPIPath,
      Token,
    } = serverContext;

    if (!shouldRender && !CurrentUser) {
      // new sign-up, no prefs to fetch
      setShouldRender(true);
    }

    if (!preferenceInitialized && CurrentUser && CurrentCustomer && CurrentAccount) {
      const preferenceUserIdOverride = new URLSearchParams(window.location.search).get('PreferenceUserId');
      // resuming existing sign-up, asynchronously fetch preference data
      PreferenceService.initialize({
        initialUserPreferences: UserPreferences,
        currentUser: CurrentUser,
        currentCustomer: CurrentCustomer,
        currentAccount: CurrentAccount,
        apiHost: CampaignAPI,
        apiPath: CampaignAPIPath,
        authToken: Token,
        isReadOnly: !!preferenceUserIdOverride,
      }).finally(() => {
        // use finally here to avoid infinitely calling preference service
        setPreferenceInitialized(true);
        setShouldRender(true);
      });
    }
  }, [preferenceInitialized, serverContext, shouldRender]);

  return (
    <PreferenceContext.Provider value={preferenceInitialized ? PreferenceService : {}}>
      {shouldRender && children}
    </PreferenceContext.Provider>
  );
}

PreferenceContextProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
};
